import React, { useState, useEffect } from 'react';
import ParticleSystem from './ParticleSystem';
import './AboutPage.css';

const AboutPage = ({ onBack }) => {
  const [showClickText, setShowClickText] = useState(false);
  const [showAboutContent, setShowAboutContent] = useState(false);
  
  useEffect(() => {
    // Show "Click to find out" text after 5 seconds (when sequence is ready)
    const clickTextTimer = setTimeout(() => {
      setShowClickText(true);
    }, 5000);
    
    // Listen for explosion (we'll use a custom event or check periodically)
    const checkExplosion = setInterval(() => {
      // Check if particles have exploded by checking if sequenceState is 'exploded'
      // For now, we'll use a timeout after click text appears
      if (showClickText) {
        // User should click, then we show content
      }
    }, 100);
    
    return () => {
      clearTimeout(clickTextTimer);
      clearInterval(checkExplosion);
    };
  }, [showClickText]);
  
  // Show about content after explosion (we'll trigger this from ParticleSystem)
  useEffect(() => {
    const handleExplosion = () => {
      setShowClickText(false);
      setTimeout(() => {
        setShowAboutContent(true);
      }, 500);
    };
    
    window.addEventListener('particleExplosion', handleExplosion);
    return () => window.removeEventListener('particleExplosion', handleExplosion);
  }, []);
  
  return (
    <div className="about-page">
      <ParticleSystem />
      <div className="about-content">
        {showClickText && !showAboutContent && (
          <div className="click-text">
            Click to find out
          </div>
        )}
        
        {showAboutContent && (
          <>
            <button className="back-button" onClick={onBack}>
              ← Back
            </button>
            
            {/* NEW INSTRUCTION */}
            <div className="rotate-instruction" style={{
                position: 'fixed',
                bottom: '30px',
                right: '30px',
                color: 'rgba(255, 255, 255, 0.6)',
                fontSize: '0.9rem',
                pointerEvents: 'none',
                zIndex: 10,
                fontFamily: 'monospace',
                textTransform: 'uppercase',
                letterSpacing: '1px'
            }}>
                Hold click & move to rotate
            </div>

            <div className="about-text">
              <h1 className="about-title">ABOUT</h1>
              
              <div className="about-section">
                <p className="about-paragraph">
                  I'm a full-stack developer passionate about creating scalable, 
                  performant applications that deliver exceptional user experiences.
                </p>
                
                <p className="about-paragraph">
                  With expertise spanning from modern frontend frameworks to robust 
                  backend architectures, I specialize in building systems that are 
                  both elegant and efficient.
                </p>
                
                <p className="about-paragraph">
                  My approach combines technical excellence with creative problem-solving, 
                  always keeping performance and user experience at the forefront of 
                  every project.
                </p>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default AboutPage;

